var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalKit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89258 75.8449C9.89258 55.3955 9.89258 45.1706 16.2317 38.8177C22.571 32.4648 32.7737 32.4648 53.1793 32.4648H74.8226C95.2279 32.4648 105.431 32.4648 111.77 38.8177C118.109 45.1706 118.109 55.3955 118.109 75.8449C118.109 96.2942 118.109 106.519 111.77 112.872C105.431 119.225 95.2279 119.225 74.8226 119.225H53.1793C32.7737 119.225 22.571 119.225 16.2317 112.872C9.89258 106.519 9.89258 96.2942 9.89258 75.8449Z",
    stroke: "white",
    strokeWidth: 7.29308
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6441 32.4654C85.6441 22.2406 85.6441 17.1282 82.4744 13.9518C79.3048 10.7754 74.2034 10.7754 64.0008 10.7754C53.7981 10.7754 48.6966 10.7754 45.527 13.9518C42.3574 17.1282 42.3574 22.2406 42.3574 32.4654",
    stroke: "white",
    strokeWidth: 7.29308
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1173 75.8447H55.8848M64.001 67.7109V83.9785",
    stroke: "white",
    strokeWidth: 7.29308,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0008 97.5343C75.954 97.5343 85.6441 87.8234 85.6441 75.8443C85.6441 63.8652 75.954 54.1543 64.0008 54.1543C52.0475 54.1543 42.3574 63.8652 42.3574 75.8443C42.3574 87.8234 52.0475 97.5343 64.0008 97.5343Z",
    stroke: "white",
    strokeWidth: 7.29308
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalKit);
export default __webpack_public_path__ + "static/media/medical-kit.c267420925df3a7c34a801f71b9a24b5.svg";
export { ForwardRef as ReactComponent };